<template>
  <div id="app">
    <Intro />
    <MediaSelector />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MediaSelector from 'bh-mod/components/file/MediaSelector'
import Intro from '@/components/models/Intro'
export default {
  name: 'app',
  components: { MediaSelector,Intro },
  data(){
    return {
      showIntro:false,
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
  methods: {

  }
}
</script>
<style>
  #app{
    min-height: 100vh;
  }
</style>
